var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ConfigContext } from 'antd/es/config-provider';
import useToken from 'antd/es/theme/useToken';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { clsx, recordToCls } from '../../../helpers/classNames';
var sizeClassNameMap = { large: 'lg', small: 'sm', middle: undefined };
export function isUnBorderedButtonType(type) {
    return type === 'text' || type === 'link';
}
export var ButtonLink = React.forwardRef(function (_a, ref) {
    var _b;
    var shape = _a.shape, _c = _a.type, type = _c === void 0 ? 'primary' : _c, ghost = _a.ghost, danger = _a.danger, size = _a.size, className = _a.className, props = __rest(_a, ["shape", "type", "ghost", "danger", "size", "className"]);
    var getPrefixCls = useContext(ConfigContext).getPrefixCls;
    var prefixCls = getPrefixCls('btn');
    var tokens = useToken();
    var sizeCls = size ? sizeClassNameMap[size] : undefined;
    var classNames = recordToCls((_b = {},
        _b["".concat(prefixCls, "-").concat(shape)] = shape !== 'default' && shape,
        _b["".concat(prefixCls, "-").concat(type)] = type,
        _b["".concat(prefixCls, "-").concat(sizeCls)] = sizeCls,
        _b["".concat(prefixCls, "-background-ghost")] = ghost && !isUnBorderedButtonType(type),
        _b["".concat(prefixCls, "-dangerous")] = danger,
        _b));
    var klassName = clsx(prefixCls, tokens[2], classNames, className);
    return React.createElement(Link, __assign({}, props, { className: klassName, ref: ref }));
});
ButtonLink.displayName = 'ButtonLink';
